import { useDispatch, useSelector } from 'react-redux';

import { updateWorkTemplatesView } from '@atom/actions/workTemplatesViewActions';
import { RootState } from '@atom/types/store';
import { WorkTemplateFolderTree } from '@atom/types/workTemplate';

export const INITIAL_PAGE = 1;
export const INITIAL_LIMIT = 25;

export interface WorkTemplatesView {
  loading: boolean;
  activeFolderId: string;
  open: Set<string>;
  workTemplateFolderTree: WorkTemplateFolderTree;
  page: number;
  limit: number;
}

export const INITIAL_WORK_TEMPLATES_VIEW: WorkTemplatesView = {
  loading: true,
  activeFolderId: 'workTypes',
  open: new Set(['workTypes']),
  // @ts-ignore
  workTemplateFolderTree: {},
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
};

interface Data {
  workTemplatesView: WorkTemplatesView;
  setWorkTemplatesView: (input: Partial<WorkTemplatesView>) => void;
}

export const useWorkTemplatesView = (): Data => {
  const dispatch = useDispatch();
  const workTemplatesView = useSelector((state: RootState) => {
    return state.workTemplatesView;
  });

  const setWorkTemplatesView = (
    newWorkTemplatesView: Partial<WorkTemplatesView>,
  ) => {
    dispatch(updateWorkTemplatesView(newWorkTemplatesView));
  };

  return {
    workTemplatesView,
    setWorkTemplatesView,
  };
};
